import { render } from "./HistoriaUsuarioExport.vue?vue&type=template&id=aa48b08c&scoped=true"
import script from "./HistoriaUsuarioExport.vue?vue&type=script&lang=js"
export * from "./HistoriaUsuarioExport.vue?vue&type=script&lang=js"

import "./HistoriaUsuarioExport.vue?vue&type=style&index=0&id=aa48b08c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa48b08c"]])

export default __exports__